import { FunctionComponent } from 'react';
import { LabelledInfoCell } from '../../../sharedComponents/sidebar/LabelledInfoCell';
import { CompoundLocation, ExpectedDeparture } from '../../compoundManagement.types';
import { DateTimeInfo } from '../../shared/dataDisplay/DateTimeInfo';
import { DisplayCancellableData } from '../../shared/dataDisplay/DisplayCancellableData';
import { DepartureCompletedForm } from '../../shared/sidebar/DepartureCompletedForm';
import { DetailsRow } from '../../shared/sidebar/DetailsRow';
import { NoValue } from '../../../sharedComponents/NoValue';
import { AddressDetails } from '../../../sharedComponents/AddressDetails';
import { DisplayDepartureFreightForwarder } from '../../shared/dataDisplay/DepartureDataContent';

export type ExpectedDepartureDetailsProps = {
    compoundVehicleId: string;
    departure: ExpectedDeparture;
    compoundLocation: CompoundLocation;
};

export const ExpectedDepartureDetails: FunctionComponent<ExpectedDepartureDetailsProps> = ({
    compoundVehicleId,
    departure,
    compoundLocation,
}) => {
    const expectedDepartureAt = departure.expectedDepartureAt;
    const isCancelled = departure.isCancelled;

    return (
        <>
            <DetailsRow className="margin-bottom-15">
                <LabelledInfoCell labelMessageId="outboundOrderBook.common.heading.to">
                    <DisplayCancellableData isCancelled={isCancelled && departure.departureTo !== undefined}>
                        <AddressDetails
                            address={departure.departureTo?.address ?? {}}
                            identifier={departure.departureTo?.identifier}
                        />
                    </DisplayCancellableData>
                </LabelledInfoCell>
                <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.expectedDepartureDate">
                    <DisplayCancellableData isCancelled={isCancelled}>
                        <DateTimeInfo date={expectedDepartureAt} timezone={compoundLocation.timeZone} />
                    </DisplayCancellableData>
                </LabelledInfoCell>
            </DetailsRow>
            <DetailsRow className="margin-bottom-15">
                <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.carrier">
                    <DisplayDepartureFreightForwarder departure={departure} />
                </LabelledInfoCell>
                <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.loadId">
                    {departure.transportInformation.loadId ? (
                        <DisplayCancellableData isCancelled={departure.isCancelled}>
                            {departure.transportInformation.loadId}
                        </DisplayCancellableData>
                    ) : (
                        <NoValue />
                    )}
                </LabelledInfoCell>
            </DetailsRow>
            <DepartureCompletedForm
                timeZone={compoundLocation.timeZone}
                compoundVehicleId={compoundVehicleId}
                meansOfTransportTypeInputDisabled
                disabled={isCancelled}
                departureCompletedAt={undefined}
                transportInformation={{
                    meansOfTransportType: departure.transportInformation.meansOfTransportType,
                    meansOfTransportId: departure.transportInformation.meansOfTransportId,
                    trailerId: departure.transportInformation.trailerId,
                }}
            />
        </>
    );
};
